module.exports = __webpack_public_path__ + "img/7cdf46c49dcf544d0580a7833262b33a.png";